import { combineReducers } from 'redux'

import dashboardReducer from './dashboardReducer'
import editorReducer from './editorReducer'

export default combineReducers({
    dashboardReducer,
    editorReducer
})
